import React from 'react'
import PropTypes from 'prop-types'
import { ErrorBoundary } from '@sainsburys-tech/bolt'
import { trackLhnCategorySelect } from '../../helpers/TaggingSerializer'
import * as Styled from './styles'

const Category = ({ itemName, id, categoryPath, type }) => {
  const onClick = () => {
    window.scrollTo(0, 0)
    trackLhnCategorySelect(itemName, id)
  }
  return (
    <ErrorBoundary>
      <Styled.CategoryItemWrapper as='li' data-el='category-item'>
        <Styled.CategoryLink
          onClick={onClick}
          to={{
            pathname: categoryPath,
            state: { type }
          }}
          data-category-id={id}>
          {itemName}
        </Styled.CategoryLink>
      </Styled.CategoryItemWrapper>
    </ErrorBoundary>
  )
}

Category.propTypes = {
  id: PropTypes.string.isRequired,
  itemName: PropTypes.string.isRequired,
  categoryPath: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired
}

export default Category
